import { AuthenticationResult, SilentRequest } from '@azure/msal-browser';
import * as React from 'react'
import { protectedResources } from '../authConfig';
import { TokenContext } from './TokenContext'
import { apiClient } from '../services/ApiClient';

const TokenContextProvider = ({ children, msalInstance }: any) => {

  const doAction = async (options:any) => {
    const token = await getToken();
    return await apiClient.doAction(options, token);
  }

  const doPublicAction = (options:any) => {
    return apiClient.doAction(options)
  }

  const doDownload = async (options:any) => {
    const token = await getToken()
    return apiClient.doDownload(options, token);
  }

  const getAccount = () => {
    const currentAccounts = msalInstance.getAllAccounts();
    if (currentAccounts === null) {
      return;
    }
    else if (currentAccounts.length >= 1) {
      console.log('currentAccounts=',currentAccounts);
      return currentAccounts[0];
    }
  }

  const getToken = async () => {
    let account = getAccount();
    let tokenRequest: SilentRequest = {
      account: account,
      scopes: protectedResources.rptApi.scopes
    }
    const result = await msalInstance.acquireTokenSilent(tokenRequest);
    return result.accessToken;
  }

  const actions = {
    getToken
  }

  return <TokenContext.Provider value={actions}>{children}</TokenContext.Provider>
}
export { TokenContextProvider }